export const LEXIS_NEXIS = 'lexisNexis';